import styled from "styled-components";
import { theme } from "../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";

export const EcoConsumptionWrapper = styled.div`
    --or-spacing-1: ${theme.space[1]}px;
    --or-spacing-2: ${theme.space[2]}px;
    --or-spacing-3: ${theme.space[3]}px;
    --or-color-grey-4: ${theme.colors.grey2};
    --or-list-highlighted-font-weight: 400;
    --or-eco-consumption-default-font-size: 1.3rem;
    --or-title-font-size: 1.6rem;
    --or-subtitle-font-size: 1.3rem;
    --or-list-hightlighted-font: ${theme.fonts.semiBold};
    --or-list-font-size: 1.3rem;
    --or-list-item-padding-x: 1.6rem;
    --list-gap: 0.6rem;

    background-color: ${theme.colors.primaryWhite};
    border: 1px solid ${theme.colors.grey2};

    .config-subitem {
        padding-inline: var(--list-item-padding-x, calc(var(--or-spacing-3) / 2));
    }
`;
